import { render, staticRenderFns } from "./InputCounter.vue?vue&type=template&id=872a6816&"
import script from "./InputCounter.vue?vue&type=script&lang=js&"
export * from "./InputCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports